export default __webpack_public_path__ + "static/media/banner2.b974b5ce.jpg";